import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/eye.svg'
import _imports_1 from '../../../assets/img/icons/edit.svg'
import _imports_2 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2"
}
const _hoisted_4 = { class: "text-paragraph fs-14" }
const _hoisted_5 = { class: "py-4 text-center text-muted" }
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 7,
  class: "d-flex justify-content-center gap-2 table-actions"
}
const _hoisted_8 = ["title", "onClick"]
const _hoisted_9 = ["alt"]
const _hoisted_10 = ["alt"]
const _hoisted_11 = ["title", "onClick"]
const _hoisted_12 = ["alt"]

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import type { Purchase } from "@/services/purchase";


export default /*@__PURE__*/_defineComponent({
  __name: 'PurchaseList',
  props: {
    purchases: {},
    loading: { type: Boolean },
    pagination: {},
    selectedIds: {},
    formatDate: { type: Function },
    getDueAmount: { type: Function },
    normalizePaymentStatus: { type: Function },
    normalizePurchaseStatus: { type: Function },
    stateStore: {}
  },
  emits: ["view-details", "delete-purchase", "delete-selected", "update:selectedIds", "table-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();

const selectedRowKeys = computed({
  get: () => props.selectedIds,
  set: (value: (string | number)[]) => {
    emit(
      "update:selectedIds",
      value.map((item) => Number(item)).filter((item) => !Number.isNaN(item))
    );
  },
});

const rowSelection = computed(() => ({
  selectedRowKeys: selectedRowKeys.value,
  onChange: (newSelectedRowKeys: (string | number)[]) => {
    selectedRowKeys.value = newSelectedRowKeys;
  },
}));

const handleTableChange = (pagination: { current?: number; pageSize?: number }) => {
  emit("table-change", pagination);
};

const paymentStatusLabel = (status?: string) =>
  t(`purchase_page.payment_status_${props.normalizePaymentStatus(status) || "pending"}`);

const purchaseStatusLabel = (status?: string) =>
  t(`purchase_page.purchase_status_${props.normalizePurchaseStatus(status) || "pending"}`);

const paymentStatusClass = (status?: string) => {
  const normalized = props.normalizePaymentStatus(status);

  return {
    "bg-success text-white": normalized === "paid",
    "bg-warning text-dark": normalized === "partial",
    "bg-danger text-white": normalized === "pending",
  };
};

const statusClass = (status?: string) => {
  const normalized = props.normalizePurchaseStatus(status);

  return {
    "bg-success text-white": normalized === "received",
    "bg-warning text-dark": normalized === "ordered" || normalized === "pending",
    "bg-info text-white": normalized === "sent",
    "bg-secondary text-white": !["received", "ordered", "pending", "sent"].includes(normalized),
  };
};

const columns = computed(() => [
  {
    title: t("purchase_page.date"),
    dataIndex: "created_at",
    key: "date",
    align: "center",
    width: 190,
    sorter: (a: Purchase, b: Purchase) =>
      new Date(a.created_at || a.date || "").getTime() - new Date(b.created_at || b.date || "").getTime(),
  },
  {
    title: t("purchase_page.reference"),
    dataIndex: "ref",
    key: "ref",
    align: "center",
    width: 130,
    sorter: (a: Purchase, b: Purchase) => String(a.ref || "").localeCompare(String(b.ref || "")),
  },
  { title: t("purchase_page.supplier"), dataIndex: "supplier_name", key: "supplier_name", align: "center", width: 190, ellipsis: true },
  { title: t("purchase_page.warehouse"), dataIndex: "warehouse_name", key: "warehouse_name", align: "center", width: 170, ellipsis: true },
  { title: t("purchase_page.status"), dataIndex: "status", key: "status", align: "center", width: 130 },
  {
    title: t("purchase_page.grand_total"),
    dataIndex: "grand_total",
    key: "grand_total",
    align: "center",
    width: 140,
    sorter: (a: Purchase, b: Purchase) => Number(a.grand_total || 0) - Number(b.grand_total || 0),
  },
  {
    title: t("purchase_page.paid"),
    dataIndex: "paid",
    key: "paid",
    align: "center",
    width: 120,
    sorter: (a: Purchase, b: Purchase) => Number(a.paid || 0) - Number(b.paid || 0),
  },
  { title: t("purchase_page.due"), key: "due", align: "center", width: 110 },
  { title: t("purchase_page.payment_status"), dataIndex: "payment_status", key: "payment_status", align: "center", width: 150 },
  { title: t("purchase_page.paid_by"), key: "paid_by", align: "center", width: 140, ellipsis: true },
  { title: t("purchase_page.action"), key: "actions", align: "center", width: 90 },
]);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.selectedIds.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("purchase_page.items_selected", { count: __props.selectedIds.length })), 1),
            _createElementVNode("button", {
              class: "btn btn-danger btn-sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete-selected')))
            }, _toDisplayString(_unref(t)("purchase_page.delete_selected")), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_table, {
        columns: columns.value,
        "data-source": __props.purchases,
        "row-key": 'id',
        loading: __props.loading,
        pagination: __props.pagination,
        "row-selection": rowSelection.value,
        scroll: { x: 1280 },
        class: "text-nowrap align-middle purchase-table",
        onChange: handleTableChange
      }, {
        emptyText: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("purchase_page.no_purchases_found")), 1)
        ]),
        bodyCell: _withCtx(({ column, record, text }) => [
          (column.key === 'date')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(__props.formatDate(record.created_at || record.date)), 1)
              ], 64))
            : (column.key === 'status')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["badge fs-14 fw-normal text-capitalize", statusClass(record.status)])
                }, _toDisplayString(purchaseStatusLabel(record.status)), 3))
              : (column.key === 'grand_total')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(__props.stateStore.formatPrice(Number(record.grand_total || 0))), 1)
                  ], 64))
                : (column.key === 'paid')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(_toDisplayString(__props.stateStore.formatPrice(Number(record.paid || 0))), 1)
                    ], 64))
                  : (column.key === 'due')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createTextVNode(_toDisplayString(__props.stateStore.formatPrice(__props.getDueAmount(record))), 1)
                      ], 64))
                    : (column.key === 'payment_status')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 5,
                          class: _normalizeClass(["badge fs-14 fw-normal text-capitalize payment-status-badge-cell", paymentStatusClass(record.payment_status)])
                        }, _toDisplayString(paymentStatusLabel(record.payment_status)), 3))
                      : (column.key === 'paid_by')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 6,
                            class: "text-capitalize paid-by-text",
                            title: record.payments?.[0]?.method?.name || record.payments?.[0]?.paid_by || _unref(t)('purchase_page.not_available_short')
                          }, _toDisplayString(record.payments?.[0]?.method?.name || record.payments?.[0]?.paid_by || _unref(t)("purchase_page.not_available_short")), 9, _hoisted_6))
                        : (column.key === 'actions')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("button", {
                                class: "btn p-0 border-0 action-icon-btn",
                                title: _unref(t)('purchase_page.view'),
                                onClick: ($event: any) => (_ctx.$emit('view-details', record))
                              }, [
                                _createElementVNode("img", {
                                  src: _imports_0,
                                  alt: _unref(t)('purchase_page.view'),
                                  style: {"width":"14px"}
                                }, null, 8, _hoisted_9)
                              ], 8, _hoisted_8),
                              _createVNode(_component_router_link, {
                                to: { name: 'EditPurchasePage', params: { id: record.id } },
                                class: "btn p-0 border-0 action-icon-btn",
                                title: _unref(t)('purchase_page.edit')
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    src: _imports_1,
                                    alt: _unref(t)('purchase_page.edit'),
                                    style: {"width":"14px"}
                                  }, null, 8, _hoisted_10)
                                ]),
                                _: 1
                              }, 8, ["to", "title"]),
                              _createElementVNode("button", {
                                class: "btn p-0 border-0 action-icon-btn",
                                title: _unref(t)('purchase_page.delete'),
                                onClick: ($event: any) => (_ctx.$emit('delete-purchase', record))
                              }, [
                                _createElementVNode("img", {
                                  src: _imports_2,
                                  alt: _unref(t)('purchase_page.delete'),
                                  style: {"width":"14px"}
                                }, null, 8, _hoisted_12)
                              ], 8, _hoisted_11)
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                              _createTextVNode(_toDisplayString(text || _unref(t)("purchase_page.not_available_short")), 1)
                            ], 64))
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination", "row-selection"])
    ])
  ]))
}
}

})